import React from 'react';
import { Box, Typography, Switch, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ControlModeTemplateField } from '@src/types/ControlModes';
import { useFields } from '../hooks/useFields';
import { useFormOperations } from '../hooks/useFormOperations';
import useAlias from '@src/hooks/useAlias';

interface FieldActionButtonsProps {
  field: ControlModeTemplateField;
}

const FieldActionButtons: React.FC<FieldActionButtonsProps> = ({ field }) => {
  const alias = useAlias();
  const { startEditField } = useFields();
  const { handleQuickConfigToggle, showDeleteConfirm } = useFormOperations();
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          ml: 1,
        }}
      >
        <Typography
          variant='caption'
          sx={{ whiteSpace: 'nowrap', opacity: 0.5 }}
        >
          {alias('Quick Config')}
        </Typography>
        <Switch
          size='small'
          checked={field.quickConfig || false}
          onChange={() => handleQuickConfigToggle(field)}
        />
      </Box>
      <IconButton
        size='small'
        sx={{ opacity: 0.6 }}
        onClick={() => startEditField(field)}
        title={alias('Edit field')}
      >
        <EditIcon fontSize='small' />
      </IconButton>
      <IconButton
        size='small'
        sx={{ opacity: 0.6 }}
        onClick={() => showDeleteConfirm('field', field)}
        title={alias('Delete field')}
      >
        <DeleteOutlineIcon fontSize='small' />
      </IconButton>
    </>
  );
};

export default FieldActionButtons;
